<div class="ub-search-filter" [ngClass]="{'elevate-search-input': searchText}">

  <mat-form-field appearance="outline" class="ub-form-input">
    <input matInput type="text" placeholder="{{ ctb.searchPlaceHolder | translate}}" [(ngModel)]="searchText"
      (keyup.enter)="onSearchApply()" (keyup)="onKeyUpFilterBlockExpand()" (input)="onSearchChange($event)"
      (click)="openSearchWindow();$event.preventDefault(); $event.stopPropagation();" />
      <div matPrefix><ubi-cell-icons name="search-icon"></ubi-cell-icons></div>
      <div matSuffix>
        <ubi-cell-icons [hidden]="_topBarConf?.currTopBarConfig?.value?.search_only" name="arrow-down-icon"
        (click)="onFilterBlockExpand()" [ngClass]="{'arrow-up' : expandFilterBlock}"></ubi-cell-icons>
      </div>
      @if (mainScreen != 'notifications') {
        @if (ctb?.tagsToDisplay?.length) {
          <div class="ub-chiplist-item" matTooltipClass="ub-tooltip"
            [matTooltip]="ctb?.tagsToDisplay[ctb?.tagsToDisplay?.length-1]?.value | superscript: true"
            [ngStyle]="{'background-color': (ctb?.tagsToDisplay[ctb?.tagsToDisplay?.length-1]?.key === 'selection') ? '#7652e9' : '#0073fd'}">
            <span>{{ ctb?.tagsToDisplay[ctb?.tagsToDisplay?.length-1]?.value | ellipsis: 20 | superscript: true }}</span>
            @if (!ctb?.tagsToDisplay[ctb?.tagsToDisplay?.length-1]?.disable_remove_filter) {
              <ubi-cell-icons name="close-icon"
              (click)="removeCommaSeparateFilter(ctb?.tagsToDisplay[ctb?.tagsToDisplay?.length-1])"></ubi-cell-icons>
            }
          </div>
        }
      }
      @if (ctb?.tagsToDisplay?.length > 1 && mainScreen != 'notifications') {
        <div
          class="ub-chiplist-dropdown">
          <div class="ub-chiplist-item more">
            ...
          </div>
          <div class="ub-chiplist-items-list">
            @for (filter of ctb.filters; track filter) {
              <div class="ub-chiplist-item">
                <span>{{ filter?.name | superscript: true }}</span>
                @if (!filter.disable_remove_filter) {
                  <ubi-cell-icons
                    name="close-icon"
                    (click)="removeFilter(filter)">
                  </ubi-cell-icons>
                }
              </div>
            }
          </div>
        </div>
      }




      @if (mainScreen == 'notifications' && ctb.filters?.length <= 1) {
        <div class="single-chiplist-filter"
          [ngClass]="{'hidden' : expandFilterBlock && ctb.filters.length <= 1}" id="">
          @for (filter of ctb.filters; track filter) {
            <div class="ub-chiplist-item forsearchbar"
              [ngStyle]="{'background-color': filter.is_outside_set == true || filter.is_outside_set == false ? '#7652e9' : '#0073fd'}"
              matTooltipClass="ub-tooltip" [matTooltip]="filter?.name | superscript: true" matTooltipClass="ub-tooltip">
              <span [ubiVUSuperscript]="filter?.name"></span>
              @if (!filter.disable_remove_filter) {
                <ubi-cell-icons name="close-icon"
                (click)="removeFilter(filter)"></ubi-cell-icons>
              }
            </div>
          }
        </div>
      }

      @if (mainScreen == 'notifications' && ctb.filters?.length > 1) {
        <div
          [ngClass]="{'hidden' : expandFilterBlock && ctb.filters.length > 1}" class="ub-notification-chips"
          id="filterHeight" #filterHeight>
          @for (filter of ctb.filters; track filter) {
            <div class="ub-chiplist-item small"
              [ngStyle]="{'background-color': filter.is_outside_set == true || filter.is_outside_set == false ? '#7652e9' : '#0073fd'}"
              matTooltipClass="ub-tooltip" [matTooltip]="filter?.name | superscript: true">
              <span>{{filter?.name | superscript: true}}</span>
              @if (!filter.disable_remove_filter) {
                <ubi-cell-icons name="close-icon"
                (click)="removeFilter(filter)"></ubi-cell-icons>
              }
            </div>
          }
        </div>
      }
    </mat-form-field>


    <!-- <ubi-cell-icons name="search-icon"></ubi-cell-icons>
    <input matInput type="text"
      placeholder="{{ ctb.searchPlaceHolder | translate}}"
      [(ngModel)]="searchText" (keyup.enter)="onSearchApply()" (keyup)="onKeyUpFilterBlockExpand()" (input)="onSearchChange($event)"
      (click)="openSearchWindow();$event.preventDefault(); $event.stopPropagation();"> -->



    </div>

    <div class="ub-search-filter-dropdown-container ">

      <!------ Location Search code -->
      @if (expandSearchBlock && !expandFilterBlock) {
        <div class="ub-search-filter-dropdown has-shadow ga-top-bar-search-dropdown" (mouseenter)="mouseEvent()"
          >
          <!-- Node/Work order search block -->
          <div class="ub-section">
            <div class="ub-list">
              <div class="up-title">
                @if (mainScreen !== 'work_order' && mainScreen !=='planning') {
                  <span>{{'node_label' | translate}} {{'search' | translate}}</span>
                }
                @if (mainScreen === 'work_order') {
                  <span>{{'work_order_id' | translate}} {{'search' | translate}}</span>
                }
                @if (mainScreen === 'planning') {
                  <span>{{'pole' | translate}} {{'search' | translate}}</span>
                }
              </div>
              <div class="ub-list-items">
                <ul>
                  <li (click)="onSearchApply(); $event.preventDefault(); $event.stopPropagation();">
                    <a href="#" autofocus>
                      <div class="ub-list-item">
                        <span class="ub-result-data">{{searchText}}</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Location search block -->
          <div class="ub-section">
            <div class="ub-list">
              <div class="up-title">
                {{'location' | translate}} {{'search' | translate}}
              </div>
              <div class="ub-list-items">
                @if (isCoordinateSearchActive && coordinateSearchRow) {
                  <ul>
                    <li
                      (click)="onCoordinateRowClicked(coordinateSearchRow); $event.preventDefault(); $event.stopPropagation();">
                      <div class="ub-list-item">
                        <a href="#">
                          <span class="ub-result-data">
                            {{ coordinateSearchRow.displayLabel }}
                          </span>
                        </a>
                      </div>
                    </li>
                  </ul>
                }
                @if (placePredictions.length > 0) {
                  <ul>
                    @for (prediction of placePredictions; track prediction) {
                      <li
                        (click)="onPlaceOfLocationClicked(prediction); $event.preventDefault(); $event.stopPropagation();">
                        <div class="ub-list-item">
                          <a href="#">
                            <span class="ub-result-data">
                              {{ prediction.description }}
                            </span>
                          </a>
                        </div>
                      </li>
                    }
                  </ul>
                }
                @if (!hasLocationSearchResults()) {
                  <ul>
                    <li>
                      <div class="ub-list-item">
                        <span class="ub-result-data">
                          {{'no_result_found' | translate}}
                        </span>
                      </div>
                    </li>
                  </ul>
                }
              </div>
            </div>
          </div>
          <!-- Recent search block -->
          @if (!_topBarConf?.currTopBarConfig?.value?.search_only) {
            <div class="ub-section">
              <div class="ub-list">
                <div class="up-title">
                  {{'recent_lable' | translate}}
                </div>
                <div class="ub-list-items">
                  <ul>
                    @for (recentfilter of ctb.recentFilters; track recentfilter) {
                      <li (click)="onRecentSearchClick(recentfilter?.filter); $event.preventDefault(); $event.stopPropagation();">
                        <div class="ub-list-item">
                          <span class="ub-result-data">{{ filterTranslate(recentfilter?.notTranslatedValue,recentfilter?.name) | ellipsis: 35 | superscript: true }}</span>
                          @if (!isLocationSearch(recentfilter?.filter)) {
                            <span class="ub-result-value">
                              {{recentfilter?.nodeCount}} {{ 'nodes_lable' | translate}}
                            </span>
                          }
                        </div>
                      </li>
                    }
                    @if (ctb.recentFilters.length === 0) {
                      <li>
                        <div class="ub-list-item">
                          <span>{{'no_recent_result_found' | translate}}</span>
                        </div>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (expandFilterBlock) {
        <div class="ub-search-filter-dropdown has-shadow ga-top-filter-dropdown">
          <div class="ub-section">
            <div class="ub-content">
              <h3>
                @switch (mainScreen) {
                  @case ('work_order') {
                    {{ totalNodesCount }} {{ 'work_orders' | translate }}
                  }
                  @case ('notifications') {
                    {{ totalNodesCount }} {{ 'alerts_header' | translate }}
                  }
                  @default {
                    {{ totalNodesCount }} {{ 'nodes' | translate }}
                  }
                }
              </h3>
            </div>
            <div class="action-buttons">
              <button mat-button class="ub-button ub-button-radius ga-top-filter-dropdown-favorite-button"
                [ngClass]="{'disabled': !ctb.enableSaveFilter}" matTooltipClass="ub-tooltip" matTooltip="{{'saved_filters' | translate}}" (click)="openSavedFilter()">
                <ubi-cell-icons name="favorite-icon"></ubi-cell-icons>
              </button>
            </div>
          </div>
          <div class="ub-section align-items-start pb-0">
            <div class="ub-content">
              @if (ctb?.filters?.length > 0) {
                <div class="ub-chips has-scroll">
                  @for (filter of ctb.filters; track filter) {
                    @if (filter.id) {
                      @for (payload of filter.payload; track payload) {
                        <div class="ub-chip"
                          [ngStyle]="{'background-color': filter.is_outside_set == true || filter.is_outside_set == false ? '#7652e9' : '#0073fd'}"
                          (click)="onAttributeClick(filter, payload.attribute, payload.value)" matTooltipClass="ub-tooltip"
                          [matTooltip]="payload?.name | superscript: true" matTooltipClass="ub-tooltip">
                          <span
                          [ubiVUSuperscript]="(mainScreen == 'notifications') || (isPowerQualityScreen()) ? (payload?.name) : (payload?.name | ellipsis: 20)"></span>
                          @if (disableRemoveFilter(payload)) {
                            <ubi-cell-icons name="close-icon"
                            (click)="removeFilter(filter, payload.name)"></ubi-cell-icons>
                          }
                        </div>
                      }
                    } @else {
                      <div class="ub-chip"
                        [ngStyle]="{'background-color': filter.is_outside_set == true || filter.is_outside_set == false ? '#7652e9' : '#0073fd'}"
                        (click)="onAttributeClick(filter)" matTooltipClass="ub-tooltip"
                        [matTooltip]="filter.name | superscript: true">
                        <span>{{ (mainScreen == 'notifications') || (isPowerQualityScreen()) ? (filter.name | superscript: true) : (filter.name | ellipsis: 20 | superscript: true) }}</span>
                        @if (!filter.disable_remove_filter) {
                          <ubi-cell-icons name="close-icon"
                          (click)="removeFilter(filter)"></ubi-cell-icons>
                        }
                      </div>
                    }
                  }
                </div>
              }
              @if (mainScreen == 'notifications' && ctb.productTypes?.length > 1) {
                <mat-form-field appearance="outline" class="ub-form-select" >
                  <mat-select placeholder="{{'product_type' | translate}}" [(ngModel)]="ctb.selectedProductType"
                    name="productType"  (selectionChange)="onChangeOfProductType($event.value)">
                    @for (productType of ctb.productTypes; track productType) {
                      <mat-option [value]="productType.key">
                        {{ productType.value | translate}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              <mat-form-field appearance="outline" class="ub-form-select">
                <mat-select placeholder="{{'attribute' | translate}}" [(ngModel)]="ctb.attribute" name="attributes"
                  (selectionChange)="changeAttribute($event,'attribute')">
                  <!-- <mat-option value="1">
                  Option 1
                </mat-option>  -->
                @for (attribute of ctb.attributes; track attribute) {
                  @if (!attribute.hidden) {
                    <mat-option [value]="attribute.value" [disabled]="attribute?.disable">
                      {{ ctb?.isDynamicFieldEnabled ? attribute.label : (attribute.name | translate) }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
            @if (ctb.subAttribute && customFields.length && ctb.attribute == 'custom_field') {
              <mat-form-field appearance="outline" class="ub-form-select">
                <mat-select  placeholder="{{'sub_attribute' | translate}}"
                  [(ngModel)]="ctb.subAttributeDetail" (selectionChange)="ctb.onChangeAttribute($event,'sub_attribute')">
                  @for (customField of customFields; track customField) {
                    <mat-option [value]="customField.name">
                      {{ customField.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (ctb.subAttribute && customFields.length && ctb.attribute == 'transformer_load') {
              <mat-form-field appearance="outline" class="ub-form-select">
                <mat-select [(ngModel)]="overloadedSelected"
                  (selectionChange)="ctb.onChangeAttribute($event,'attributeValue')"
                  placeholder="{{'value' | translate}}">
                  @for (obj of transformer_load; track obj) {
                    <mat-option [value]="obj.name">
                      {{ obj.name | titlecase }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (ctb.subAttribute && ctb.gisAssetsAttributes.length && ctb.attribute == 'gis_asset') {
              <mat-form-field appearance="outline" class="ub-form-select">
                <mat-select  placeholder="{{'sub_attribute' | translate}}"
                  [(ngModel)]="ctb.subAttributeDetail" name="gisAssetsAttributes"
                  (selectionChange)="ctb.onChangeAttribute($event,'sub_attribute')">
                  @for (gisAssets of ctb.gisAssetsAttributes; track gisAssets) {
                    @if (!gisAssets.hidden) {
                      <mat-option [value]="gisAssets.name">
                        {{ gisAssets.name | titlecase }}
                      </mat-option>
                    }
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (ctb.attribute && ctb.attributeOperators.length && ctb.displayValue) {
              <mat-form-field appearance="outline" class="ub-form-select">
                <mat-select
                  [placeholder]="ctb.isCustomFieldDropdownFilter ? ('value' | translate) : (ctb.attribute === 'open_work_order' ? ('state' | translate) : ('operator' | translate))"
                  [(ngModel)]="ctb.attributeOperator"  name="operators"
                  [disabled]="!ctb.attribute" (selectionChange)="ctb.onChangeAttribute($event,'attributeOperator')">
                  @for (attributeOperator of ctb.attributeOperators; track attributeOperator) {
                    <mat-option [value]="attributeOperator.value"
                      [disabled]="!attributeOperator.selectable">
                      {{ ctb.isCustomFieldDropdownFilter ? attributeOperator.name : (attributeOperator.name | translate) }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
        @if (!(ctb.attribute === 'open_work_order' && ctb.attributeOperator === '!=')) {

          @if (ctb.attributeValueInput && ctb.attributeValueInput == 'dropdown') {
                <mat-form-field appearance="outline" class="ub-form-select ub-filter-max-width-dropdown"
                  >
                  @if (ctb.attributeValueInputType != 'multiple') {
                    <mat-select  placeholder="{{'value' | translate}}"
                      [(ngModel)]="ctb.attributeValue" name="values" [disabled]="ctb.attributeValueInputDisable"
                      panelClass="ub-filter-value-dropdown-panel"
                      (selectionChange)="ctb.onChangeAttribute($event,'attributeValue')"
                      >
                      @for (attributeValue of ctb.attributeValues; track attributeValue) {
                        <mat-option [value]="attributeValue.value"
                          [disabled]="!attributeValue.selectable">
                          <span>{{ attributeValue.name | translate | superscript: true }}</span>
                        </mat-option>
                      }
                    </mat-select>
                  }
                  <!--  {{attributeValues | json}}  -->
                  @if (ctb.attributeValueInputType && ctb.attributeValueInputType == 'multiple') {
                    <mat-select placeholder="{{'value' | translate}}" multiple [(ngModel)]="ctb.attributeValue" name="values"
                      panelClass="has-checkbox ub-form-select ub-form-select-multiple ub-filter-dropdown-align ub-filter-value-dropdown-panel"
                      (selectionChange)="ctb.onChangeAttribute($event,'attributeValue')"
                      >
                      @if (ctb.attribute !== 'venue' && ctb.attribute !== 'tag') {
                        <mat-select-trigger>
                          @for (value of ctb.attributeValue; track value; let last = $last) {
                            @for (attributeValue of ctb.attributeValues; track attributeValue) {
                              @if ((ctb.isNumber(attributeValue.value) ? attributeValue.value : attributeValue.value.toString()) === value) {
                                <span
                                [ubiVUSuperscript]="((mainScreen === 'notifications') || isPowerQualityScreen() ? attributeValue.name : ctb.translateAlert(attributeValue.name))"></span>
                              }
                            }
                            @if (!last) {
                              <span>, </span>
                            }
                          }
                        </mat-select-trigger>
                      }
                      @if (ctb.attribute === 'venue' || ctb.attribute === 'tag') {
                        <ngx-mat-select-search
                          [(ngModel)]="ctb.searchBy" noEntriesFoundLabel="{{'no_options_found' | translate}}"
                        placeholderLabel="{{'search' | translate}}" name="search-by"></ngx-mat-select-search>
                      }
                      @if (ctb.attribute === 'venue' || ctb.attribute === 'tag') {
                        @for (attributeValue of ctb.attributeValues | filterTag:ctb.searchBy; track attributeValue) {
                          <mat-option
                            [value]="attributeValue.value" [disabled]="!attributeValue.selectable">
                            {{ attributeValue.name | translate }}
                          </mat-option>
                        }
                      } @else {
                        @for (attributeValue of ctb.attributeValues; track attributeValue) {
                          @if (!attributeValue.hidden) {
                            <mat-option
                              [value]="ctb.isNumber(attributeValue.value) ? attributeValue.value : attributeValue.value.toString()"
                              [disabled]="!attributeValue.selectable">
                              <span
                              [ubiVUSuperscript]="((mainScreen === 'notifications') || isPowerQualityScreen() ? attributeValue.name : ctb.translateAlert(attributeValue.name))"></span>
                            </mat-option>
                          }
                        }
                      }
                    </mat-select>
                  }
                </mat-form-field>
              }
            }
            @if (ctb.attributeValueInput && ctb.attributeValueInput == 'text' && ctb.displayValue) {
              <mat-form-field  appearance="outline" class="ub-form-select"
                >
                @if (ctb.attributeValueInputType == 'number' && ctb.attribute === 'custom_field') {
                  <input matInput type="text" placeholder="{{'value' | translate}}" [(ngModel)]="ctb.attributeValue"
                    [disabled]="ctb.attributeValueInputDisable" (keypress)="validateDecimalCustomKey($event)"
                    (keyup)="ctb.onChangeAttribute($event,'attributeValue')" ubiCellDecimaNumber>
                  }
                  @if (ctb.attribute === 'firmwareVersion' || ctb.attribute === 'versionState') {
                    <input matInput type="text" placeholder="{{'value' | translate}}" [(ngModel)]="ctb.attributeValue"
                      [disabled]="ctb.attributeValueInputDisable" (keypress)="validateVersionInput($event)"
                      (keyup)="ctb.onChangeAttribute($event,'attributeValue')">
                    }
                    @if (!(ctb.attributeValueInputType == 'number' && ctb.attribute === 'custom_field') && !(ctb.attribute === 'firmwareVersion' || ctb.attribute === 'versionState')) {
                      <input matInput type="{{ctb.attributeValueInputType}}" placeholder="{{'value' | translate}}"
                        [(ngModel)]="ctb.attributeValue" [disabled]="ctb.attributeValueInputDisable"
                        (keyup)="ctb.onChangeAttribute($event,'attributeValue')"
                        (change)="ctb.onChangeAttribute($event,'attributeValue')">
                      }
                    </mat-form-field>
                  }
                  @if (ctb.attributeValueInput && ctb.attributeValueInput == 'dateTimePicker') {
                    <mat-form-field appearance="outline"  class="ub-form-select"
                      >
                      <input matInput [matDatepicker]="picker" (click)="picker.open()" autocomplete="off" readonly
                        [max]="ctb.maxDate" [(ngModel)]="ctb.attributeDateValue" [disabled]="ctb.attributeValueInputDisable"
                        (keyup)="ctb.onChangeAttribute($event, 'ctb.attributeDateValue')"
                        (change)="ctb.onChangeAttribute($event, 'attributeValue')"
                        (dateChange)="ctb.onChangeAttribute($event, 'attributeValue')" />
                        <ubi-cell-icons name="calendar-icon" matPrefix></ubi-cell-icons>
                        <!-- <mat-datepicker-toggle matPrefix [for]="picker">
                        <ubi-cell-icons name="calendar-icon" matPrefix matDatepickerToggleIcon></ubi-cell-icons>
                      </mat-datepicker-toggle> -->
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  }
                  @if (ctb.attributeValueInput && ctb.attributeValueInput == 'dateTimePicker') {
                    <mat-form-field appearance="outline" class="ub-form-select"
                      >
                      <input matInput type="time" [(ngModel)]="ctb.attributeTimeValue" [disabled]="ctb.attributeValueInputDisable"
                        (keyup)="ctb.onChangeAttribute($event, 'ctb.attributeTimeValue')"
                        (change)="ctb.onChangeAttribute($event, 'attributeValue')" />
                        <ubi-cell-icons name="clock-icon" matPrefix></ubi-cell-icons>
                      </mat-form-field>
                    }
                  </div>
                  <div class="action-buttons">
                    <button mat-button class="ub-button ub-button-radius"
                      [disabled]="!expandFilterBlock || !ctb.filters.length || (ctb.filters.length == 1 && this.ctb.filters[0].payload[0].period == ctb.defaultPeriod && !this.ctb.filters[0]?.userFilter)"
                      (click)="onResetFilter();">
                      <ubi-cell-icons name="reset-icon"></ubi-cell-icons>
                    </button>
                    @if (ctb?.filters?.length > 0) {
                      <button mat-button class="ub-button ub-button-radius ga-filters-chip-more-button"
                        [disabled]="!ctb.requestFilter.length || ctb.isDisabledSaveFilter" (click)="saveNodeFilter()">
                        <ubi-cell-icons name="save-icon"></ubi-cell-icons>
                      </button>
                    }
                    @if (!ctb.enableAddAttribute) {
                      <button mat-button class="ub-button ub-button-radius mt-auto ga-filters-attr-button" matTooltipClass="ub-tooltip" matTooltip="{{'add_filters' | translate}}" disabled
                        >
                        <ubi-cell-icons name="plus-icon"></ubi-cell-icons>
                      </button>
                    }
                    @if (ctb.enableAddAttribute) {
                      <button mat-button class="ub-button ub-button-radius mt-auto selected ga-filters-attr-button"
                        matTooltipClass="ub-tooltip" matTooltip="{{'add_filters' | translate}}" (click)="ctb.addFilter(); closeExpandFilterBlock();">
                        <ubi-cell-icons name="plus-icon"></ubi-cell-icons>
                      </button>
                    }
                  </div>
                </div>
                <!----------------- Notification Section -------------------------->
                @if ((mainScreen == 'notifications') || (isPowerQualityScreen() || mainScreen == 'work_order')) {
                  <div class="ub-section">
                    <div class="ub-content">
                      <div class="up-title">
                        {{ 'date_range' | translate}}
                      </div>
                    </div>
                    <div class="action-buttons">
                      @if (mainScreen !== 'work_order') {
                        <button mat-button class="ub-button ub-button-radius" [disabled]=""
                          [ngClass]="{selected: ctb.isCalenderVisible}" (click)="onSelectDateRangeFromCal()">
                          <ubi-cell-icons name="calendar-icon"></ubi-cell-icons>
                        </button>
                      }
                    </div>
                  </div>
                  <div class="ub-section">
                    @if (mainScreen !== 'work_order') {
                      <ng-container class="filter-block">
                        <mat-radio-group class="ub-radio-group" [(ngModel)]="ctb.selectedDateRange"
                          (change)="onDateRangeChange($event)">
                          <div class="row no-gutters">
                            @for (dateRange of ctb.dateRange; track dateRange) {
                              <div class="col-{{dateRange.gap_value}}">
                                <mat-radio-button class="ub-form-radio" [value]="dateRange.key" [disabled]="dateRange.is_disabled"
                                  [ngClass]="dateRange.value" matTooltipClass="ub-tooltip"
                                  matTooltip="{{ dateRange.is_disabled ? ('temporal_view_disable_info'  | translate) : null}}">
                                  <span>{{dateRange.value | translate}}</span>
                                </mat-radio-button>
                              </div>
                            }
                          </div>
                        </mat-radio-group>
                      </ng-container>
                    }
                  </div>
                  @if (ctb.isCalenderVisible) {
                    <div class="ub-section">
                      <div class="ub-content">
                        <ubi-cell-ubvi-calendar-view [startDate]="ctb?.startDate" [endDate]="ctb?.endDate" [displayMonths]="1"
                          [canCompareDates]="false" [minDate]="ctb?.minDate" [maxDate]="ctb?.maxDate"
                          [isUnlimitedDaysSelection]="ctb?.selectedPeriod === 'day'" [color]="'blue'"
                          [isComparisonDatesSelected]="false" [minDaySelection]="isPowerQualityTemporalViewEnable ? 1 : null"
                          (selectedStartDate)="onChangeStartDate($event)" (selectedEndDate)="onChangeEndDate($event)">
                        </ubi-cell-ubvi-calendar-view>
                      </div>
                    </div>
                    <div class="ub-section">
                      <div class="ub-content ub-date-time-select">
                        <div class="row">
                          <div class="col-12">
                            <div class="time-window">
                              {{ 'time_window' | translate}}
                              <mat-slide-toggle class="ub-slide" labelPosition="before" (click)="$event.stopPropagation();"
                                [disabled]="!ctb?.startDate" (change)="allDayToggle($event);"
                                [checked]="ctb?.allDaySelected"><span class="mr-2">{{ 'all_day' | translate }} </span>
                              </mat-slide-toggle>
                            </div>
                          </div>
                          <div class="col-6">
                            <mat-form-field appearance="outline" class="ub-form-input">
                              <input matInput type="time" [(ngModel)]="ctb.startTime" (ngModelChange)="onChangeStartTime($event)"
                                [disabled]="ctb?.allDaySelected" />
                                <!-- <span class="ubicon-clock icon-md" matPrefix></span> -->
                                <ubi-cell-icons name="clock-icon" matPrefix></ubi-cell-icons>
                              </mat-form-field>
                            </div>
                            <div class="col-6">
                              <mat-form-field appearance="outline" class="ub-form-input">
                                <input matInput type="time" [(ngModel)]="ctb.endTime" (ngModelChange)="onChangeEndTime($event)"
                                  [disabled]="ctb?.allDaySelected" />
                                  <!-- <span class="ubicon-clock icon-md" matPrefix></span> -->
                                  <ubi-cell-icons name="clock-icon" matPrefix></ubi-cell-icons>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="action-buttons">
                            @if (!ctb.isDateRangeAttributeAdded) {
                              <button mat-button class="ub-button ub-button-radius ga-filters-attr-button mt-auto" disabled>
                                <ubi-cell-icons name="plus-icon"></ubi-cell-icons>
                              </button>
                            }
                            @if (ctb.isDateRangeAttributeAdded) {
                              <button mat-button class="ub-button ub-button-radius selected mt-auto ga-filters-attr-button"
                                (click)="ctb.addDateRangeToFilter(); closeExpandFilterBlock();">
                                <ubi-cell-icons name="plus-icon"></ubi-cell-icons>
                              </button>
                            }
                          </div>
                        </div>
                      }
                    }
                    <div class="ub-section">
                      <div class="ub-list">
                        <div class="up-title">
                          {{'recent_lable' | translate}}
                        </div>
                        <div class="ub-list-items pt-2">
                          <ul>
                            @for (recentfilter of ctb.recentFilters; track recentfilter) {
                              <li (click)="onRecentSearchClick(recentfilter?.filter)" matTooltipClass="ub-tooltip" [matTooltip]="filterTranslate(recentfilter?.notTranslatedValue,recentfilter?.name) | superscript: true">
                                <div class="ub-list-item">
                                  <span class="ub-result-data">{{ filterTranslate(recentfilter?.notTranslatedValue,recentfilter?.name) | ellipsis: 35 | superscript: true }}</span>
                                  @if (!isLocationSearch(recentfilter?.filter) && mainScreen != 'notifications') {
                                    <span class="ub-result-value">
                                      {{recentfilter?.nodeCount}}
                                      {{ mainScreen == 'work_order' ? ('work_order(s)' | translate) : ('nodes_lable' | translate) }}
                                    </span>
                                  }
                                </div>
                              </li>
                            }
                            @if (ctb.recentFilters.length === 0) {
                              <li>
                                <span>{{'no_recent_result_found' | translate}}</span>
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                </div>
              }
